module.exports = __webpack_public_path__ + "static/media/tools.f6cfa910.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tools.png
// module id = 87
// module chunks = 0